import { attendantCompaniesApi } from 'app/services/api';

import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const ATTENDANT_COMPANIES_ACTION_TYPE = createNamedActions(
  // LOAN_APPLICATION_ACTION_NAME_PREFIX is used for Redux Middleware in Loan Editor
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/attendant-companies`,
  {
    GET_ATTENDANT_COMPANIES_DATA: 'GET_ATTENDANT_COMPANIES_DATA',
  },
);

export const getAttendantCompaniesAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await attendantCompaniesApi.getAttendantCompanies();

  return dispatch({
    type: ATTENDANT_COMPANIES_ACTION_TYPE.GET_ATTENDANT_COMPANIES_DATA,
    payload: data,
  });
});
